const retryKey = "precise-plate-stale-page-retry";
const splashBypassKey = "precise-plate-skip-splash-once";

export function takeStalePageRetrySlot(): boolean {
  try {
    if (window.sessionStorage.getItem(retryKey)) return false;
    window.sessionStorage.setItem(retryKey, "1");
    window.sessionStorage.setItem(splashBypassKey, "1");
    return true;
  } catch {
    return true;
  }
}

export function consumeStalePageSplashBypass(): boolean {
  try {
    const shouldBypass = window.sessionStorage.getItem(splashBypassKey) === "1";
    window.sessionStorage.removeItem(splashBypassKey);
    return shouldBypass;
  } catch {
    return false;
  }
}

export function clearStalePageRetrySlot(): void {
  try {
    window.sessionStorage.removeItem(retryKey);
  } catch {
    // Storage can be unavailable in some private browsing modes.
  }
}
